"use client";

import { useEffect } from "react";
import { Box, LinearProgress } from "@mui/material";

export default function TopLoadingProgress({ onShown = () => {} }) {
  useEffect(() => {
    onShown();
  }, [onShown]);

  return (
    <Box
      aria-label="Loading"
      role="status"
      sx={{
        position: "fixed",
        top: 0,
        right: 0,
        left: 0,
        zIndex: 2147483647,
        pointerEvents: "none",
      }}
    >
      <LinearProgress
        color="primary"
        sx={{
          height: 2,
          "& .MuiLinearProgress-bar1Indeterminate, & .MuiLinearProgress-bar2Indeterminate": {
            animationDuration: "2.8s",
          },
        }}
      />
    </Box>
  );
}
